/**
 * BrandListContainer
 * --
 */
import React from 'react';
import BrandListPresenter from './BrandListPresenter';

const BrandListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <BrandListPresenter />
    </>
  );
};

export default BrandListContainer;
